import { Navigate, Outlet } from "react-router-dom";
import { Unauthorized } from "./features/core/components/Unauthorized";
import { useAuthorizedBrands } from "./features/core/hooks/useAuthorizedBrands";
import { useLastPath } from "./features/core/hooks/useLastPath";
import { Module } from "./features/ui/components/Module";

export const BrandPicker = () => {
  const lastPath = useLastPath();
  const brands = useAuthorizedBrands();

  if (!brands) {
    return null;
  }

  if (!brands.length) {
    return (
      <Module>
        <Unauthorized/>
      </Module>
    );
  }

  if (lastPath === "") {
    return <Navigate to={`${brands[0].urlSlug}`} replace={true}/>;
  }

  return <Outlet/>;
};
